import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AppConfig from "../../AppConfig";

// First, create the thunk
const fetchAttendance = createAsyncThunk("attendance/fetchAttendance", async () => {
  try {
    // Retrieve state from localStorage

    var result = await AppConfig.PostData(
      `account/ping`,
      "GET",
      null,
      false,
      false
    );
    if (result.status === 200) {
      let attendance = await result.json();
      return attendance;
    } else {
      return null;
    }
  } catch (error) {
    return [...error.message];
  }
});

const initialState = {
  attendance: {},
  isAuthenticated: false,
  error: "",
  loading: "idle", // 'idle' | 'pending' | 'succeeded' | 'failed'
};

export const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    setAttendance: (state, action) => {
      state.attendance = [...action.payload];
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(fetchAttendance.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.loading = "succeeded";
        if (action.payload !== null) {
          state.attendance = action.payload;
          state.isAuthenticated = true;
        } else {
          localStorage.setItem('access_token', null);
          state.error = "Invalid login!";
        }
      })
      .addCase(fetchAttendance.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setError, setAttendance } = attendanceSlice.actions;
export { fetchAttendance };

export default attendanceSlice.reducer;
